import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo, footerNavigation } from '../../data/mock';
import '../../styles/footer.css';
import { soemLogo } from '../../assets';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <img 
              src={soemLogo} 
              alt={companyInfo.name}
              className="footer-logo"
            />
            <p className="footer-tagline">{companyInfo.tagline}</p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-title">Enlaces</h4>
            <nav className="footer-nav">
              {footerNavigation.map((item) => (
                <Link key={item.path} to={item.path} className="footer-link">
                  {item.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-title">Contacto</h4>
            <div className="contact-info">
              <a href={`mailto:${companyInfo.email}`} className="contact-item">
                <Mail size={16} />
                <span>{companyInfo.email}</span>
              </a>
              <a href={`tel:${companyInfo.phone}`} className="contact-item">
                <Phone size={16} />
                <span>{companyInfo.phone}</span>
              </a>
              <div className="contact-item">
                <MapPin size={16} />
                <span>{companyInfo.address}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} {companyInfo.name}. Todos los derechos reservados.</p>
          <div className="footer-legal">
            <Link to="/legal">Aviso de Privacidad</Link>
            <span>|</span>
            <Link to="/legal">Términos de Uso</Link>
            <span>|</span>
            <Link to="/privacidad-app">Privacidad App Móvil</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
